
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/submit-documents/pennsylvania-pip-document-upload",
      function () {
        return require("private-next-pages/g/submit-documents/pennsylvania-pip-document-upload.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/submit-documents/pennsylvania-pip-document-upload"])
      });
    }
  